import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

export const AuthLayout = () => (
  <Box sx={{ height: '100vh', display: 'flex', overflow: 'hidden' }}>
    <Outlet />
  </Box>
);
